import { API_ENDPOINTS, API_HEADERS } from "../constants/api";
import { InitiativePost } from "../types";

interface PaginatedInitiativesResponse {
  results?: InitiativePost[];
  total?: number;
}

export const fetchInitiativePosts = async (): Promise<InitiativePost[]> => {
  const response = await fetch(API_ENDPOINTS.initiatives, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(
      `Initiatives request failed with status ${response.status}`
    );
  }

  const data: PaginatedInitiativesResponse | InitiativePost[] =
    await response.json();

  if (Array.isArray(data)) {
    return data;
  }

  if (Array.isArray(data?.results)) {
    return data.results;
  }

  return [];
};

export const fetchInitiativeDetail = async (
  id: number | string
): Promise<InitiativePost | null> => {
  const response = await fetch(API_ENDPOINTS.initiativeDetail(id), {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(
      `Initiative detail request failed with status ${response.status}`
    );
  }

  const data: InitiativePost = await response.json();
  return data || null;
};
